import { Directive, Input, OnChanges, OnInit, Optional, SimpleChanges } from '@angular/core';
import { Dropdown } from 'primeng/dropdown';
import { NgControl, Validators } from '@angular/forms';

@Directive({
    selector: 'p-dropdown'
})
export class DropdownConfigDirective implements OnChanges, OnInit {
    @Input() filter = false;
    @Input() options: any[] = [];
    @Input() required = false;
    @Input() readonly = false;
    @Input() virtualScroll: boolean;
    @Input() removeClearButton = false;

    constructor(
        private select: Dropdown,
        @Optional() private control: NgControl
    ) {}

    ngOnInit(): void {
        this.configShowClear();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.filter || changes.options) {
            this.configFilter();
            this.configVirtualScroll();
        }
        if (changes.required || changes.readonly) {
            this.configShowClear();
        }
    }

    private configFilter(): void {
        if (this.filter) {
            this.select.filter = this.options ? this.options.length > 5 : false;
            this.select.cd.markForCheck();
        }
    }

    private configVirtualScroll(): void {
        if (this.virtualScroll === null || this.virtualScroll === undefined) {
            if (this.options && this.options.length > 200) {
                this.select.virtualScroll = true;
                this.select.itemSize = 50;
            } else {
                this.select.virtualScroll = false;
                this.select.itemSize = null;
            }
        }
    }

    private configShowClear(): void {
        this.select.showClear = !this.removeClearButton && !this.isRequired() && !this.readonly;
    }

    private isRequired(): boolean {
        return this.required || this.control?.control.hasValidator(Validators.required);
    }
}
